import React from "react";
import NutritionistInitialInspection from "../IpEMR/Nutritionist/NutritionistInitialInspection/NutritionistInitialInspection";
import NutritionistInitialAssessmentProvider from "../IpEMR/InspectionForms/HistoryForm/NutritionistInitialAssessmentProvider.js";
import RiskAssessment from "../IpEMR/Nutritionist/RiskAssessment/RiskAssessment.js";
import RiskAssessmentFormProvider from "../IpEMR/Nutritionist/RiskAssessment/RiskAssessmentFormProvider.js";
import ChatTabs from "./Chat/ChatTabs";

const NutritionistIP = ({ patientData, params, refreshPage }) => {
  return (
    <>
      {params?.type === "ia" || params?.type === "nutritionist" ? (
        <NutritionistInitialAssessmentProvider>
          <NutritionistInitialInspection
            refreshPage={refreshPage}
            editId={patientData?.nutrition_initial_assessment}
            patientData={patientData}
          />
        </NutritionistInitialAssessmentProvider>
      ) : params?.type === "risk_assessment" ? (
        <RiskAssessmentFormProvider>
          <RiskAssessment
            riskAssessment={patientData?.nutrition_risk_assessment}
            iAssessment={patientData?.nutrition_initial_assessment}
            refreshPage={refreshPage}
            patientData={patientData}
          />
        </RiskAssessmentFormProvider>
      ) : params?.type === "chat" ? (
        <ChatTabs patientData={patientData} />
      ) : null}
    </>
  );
};

export default NutritionistIP;
